import React, { useEffect, useContext, useState } from "react";
import Navigation from "../../Components/Navigation";
import Footer from "../../Components/Footer";
import HeroAlt from "../../Components/HeroAlt";
import { MondayContext } from "../../Contexts/MondayContext";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

import Grid from "@mui/material/Grid2";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContactRibbon from "../../Components/ContactRibbon";

export default function Meetings() {
  const { meetingsData } = useContext(MondayContext);
  // console.log(meetingsData);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Meetings";
  }, []);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <main>
      <Navigation />
      <HeroAlt title="Our Meetings" />
      <section>
        <Grid
          container
          size={12}
          justifyContent="center"
          backgroundColor="#f4f4f4"
          padding="2% 0"
          spacing={2}
        >
          {/*UPCOMING MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            <Grid size={12}>
              <h1>Upcoming Meetings</h1>
            </Grid>
            <Grid size={12} padding="1% 0">
              <p>
                Community meetings provide an opportunity to listen to residents
                and gather valuable input and feedback on important local
                concerns and ideas. These meetings will be held in various
                locations across eastern Alachua County. Upcoming dates and
                times are currently being scheduled.{" "}
              </p>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }}
          >
            {meetingsData ? (
              meetingsData[0].length > 0 ? (
                meetingsData[0].map((item) => (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={item.id}
                    expanded={expanded === item.id}
                    onChange={handleChange(item.id)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${item.id}-content`}
                      id={`panel${item.id}-header`}
                    >
                      <Typography>
                        <strong>Meeting Name : </strong>
                        {item.MeetingName}
                        <br />
                        <strong>Date & Time : </strong>
                        {new Date(item.DateTime).toLocaleString("en-US", {
                          month: "long",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })}
                        <br />
                        <strong>Location : </strong>
                        {item.Location}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography variant="body2">
                        <strong>Description:</strong> {item.Description}
                      </Typography>
                      {item.Attachments.length > 0 ? (
                        <Typography variant="body2" sx={{ marginTop: 1 }}>
                          <strong>Attachments:</strong>
                          {item.Attachments.map((attachment, index) => (
                            <div key={index}>
                              <a
                                href={attachment[1]}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {attachment[0]}
                              </a>
                            </div>
                          ))}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{ textAlign: "center" }}
                >
                  There are Currently No Upcoming Meetings
                </Typography>
              )
            ) : (
              <Accordion sx={{ width: "100%" }}slotProps={{ heading: { component: 'div' } }}>
                <Stack spacing={1} sx={{ padding: 2 }}>
                  <Skeleton
                    variant="rounded"
                    height={16}
                    animation="wave"
                    width="70%"
                  />
                  <Skeleton
                    variant="rounded"
                    height={16}
                    animation="wave"
                    width="40%"
                  />
                  <Skeleton
                    variant="rounded"
                    height={16}
                    animation="wave"
                    width="95%"
                  />
                </Stack>
              </Accordion>
            )}
          </Grid>
        </Grid>
      </section>
      {/*PAST MEETINGS SECTION */}
      <section>
        <Grid
          container
          size={12}
          justifyContent="center"
          backgroundColor="#f4f4f4"
          paddingTop="2%"
          paddingBottom="4%"
          spacing={2}
        >
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            <Grid size={12}>
              <h1>Past Meetings</h1>
            </Grid>
          </Grid>
          <Grid container size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }}>
            {meetingsData ? (
              meetingsData[1].length > 0 ? (
                meetingsData[1].map((item) => (
                  <Accordion
                    key={item.id}
                    expanded={expanded === item.id}
                    onChange={handleChange(item.id)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${item.id}-content`}
                      id={`panel${item.id}-header`}
                    >
                      <Typography>
                        <strong>Meeting Name : </strong>
                        {item.MeetingName}
                        <br />
                        <strong>Date & Time : </strong>
                        {new Date(item.DateTime).toLocaleString("en-US", {
                          month: "long",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })}
                        <br />
                        <strong>Location : </strong>
                        {item.Location}
                      </Typography>{" "}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography variant="body2">
                        <strong>Description:</strong> {item.Description}
                      </Typography>
                      {item.Attachments.length > 0 ? (
                        <Typography variant="body2" sx={{ marginTop: 1 }}>
                          <strong>Attachments:</strong>
                          {item.Attachments.map((attachment, index) => (
                            <div key={index}>
                              <a
                                href={attachment[1]}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {attachment[0]}
                              </a>
                            </div>
                          ))}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <Typography variant="h5" fontWeight="bold">
                  There are Currently No Past Meetings
                </Typography>
              )
            ) : (
              <Accordion sx={{ width: "100%" }} slotProps={{ heading: { component: 'div' } }}>
                <Stack spacing={1} sx={{ padding: 2 }}>
                  <Skeleton
                    variant="rounded"
                    height={16}
                    animation="wave"
                    width="70%"
                  />
                  <Skeleton
                    variant="rounded"
                    height={16}
                    animation="wave"
                    width="40%"
                  />
                  <Skeleton
                    variant="rounded"
                    height={16}
                    animation="wave"
                    width="95%"
                  />
                </Stack>
              </Accordion>
            )}
          </Grid>
        </Grid>
      </section>

      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}
